// Testi verificati sulla dashboard il 2026-10-16 (vedi piano guide operative).
export default {
  slug: 'anagrafiche',
  module: 'employees',
  title: 'Le anagrafiche dipendenti',
  tile: 'Trova una persona, aggiungi un nuovo assunto, consulta la sua scheda.',
  minutes: 4,
  publishedAt: '2026-10-26T09:00:00.000Z',
  moduleLabel: 'Apri i dipendenti',
  modulePath: 'employees',
  brief: {
    purpose: 'Avere in un unico posto i dati di ogni dipendente, dal contratto ai documenti.',
    who: "Chi in azienda gestisce il personale e l'amministrazione.",
    when: "A ogni assunzione, cessazione o quando ti serve un'informazione su una persona.",
  },
  steps: [
    {
      title: 'Trova un dipendente',
      text: 'Nella pagina Dipendenti scegli chi vedere con le schede in alto, poi scrivi un nome nel campo di ricerca.',
      screen: 'anagrafiche-1',
      notes: ['Attivi è la vista di partenza; in Cessati trovi chi non lavora più con voi', 'Scrivi nome, cognome o matricola'],
    },
    {
      title: 'Aggiungi un nuovo assunto',
      text: "Premi «Aggiungi dipendente», compila i dati richiesti e salva. La persona compare subito nell'elenco.",
      screen: 'anagrafiche-2',
      notes: ['Il pulsante compare se hai il permesso di creare dipendenti'],
      tip: 'Devi inserire tante persone insieme? Con «Importa» le carichi tutte da un unico file.',
    },
    {
      title: 'Apri la scheda del dipendente',
      text: "Clicca una riga dell'elenco: si apre la scheda della persona, divisa in sezioni.",
      screen: 'anagrafiche-3',
      notes: [
        'Dati Anagrafici e Dati Rapporto di Lavoro: chi è e con quale contratto',
        'Documenti, Scadenziario e Timeline: file, scadenze e storia della persona',
      ],
    },
    {
      title: "Esporta l'elenco",
      text: 'Premi «Esporta»: scegli «Anagrafica corrente», «Anagrafica a una data» o «Storico delle variazioni» e scarica il file Excel.',
      screen: 'anagrafiche-4',
      notes: ['Scegli cosa esportare e scarica il file Excel'],
    },
  ],
  faq: [
    {
      question: 'Dove trovo chi non lavora più in azienda?',
      answer: 'Nella scheda «Cessati» della pagina Dipendenti: i dati restano consultabili.',
    },
    {
      question: 'Non vedo il pulsante «Aggiungi dipendente»',
      answer: "Serve il permesso di creare dipendenti. Chiedilo a chi amministra l'account HeyJob della tua azienda.",
    },
  ],
};
